import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import Navbar from './components/Navbar';
import Carousel from './components/Carousel';
import Galeria from './components/Galeria';
import Eventos from './components/Eventos';
import Mapa from './components/Mapa';
import AppFooter from './components/AppFooter';
import Cultos from './components/Cultos';
import PedidoDeOracion from './components/PedidoDeOracion';
import NuestraFe from './components/NuestraFe'; // Import the new page
import Kids from './components/Kids';
import MaterialDeLectura from './components/MaterialDeLectura';
import 'antd/dist/reset.css';

function App() {
  const [selected, setSelected] = useState('Inicio');

  return (
    <Router>
      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Navbar selected={selected} setSelected={setSelected} />{' '}
              {/* Pass both selected and setSelected */}
              <Carousel setSelected={setSelected} />
              <Galeria
                folderId={process.env.REACT_APP_GOOGLE_DRIVE_FOLDER_ID}
                title="Galería"
              />
              <Eventos />
              <Mapa />
              <Cultos
                title="Nuestros cultos"
                description="Accedé gratuitamente a nuestros cultos en forma de video o audio escaneando el QR."
                qrUrl="https://drive.google.com/drive/folders/1iWVZXsXIY8TrT53fQxKL8LBZBav3z34q?usp=sharing"
                buttonText="Ver cultos"
              />
              <PedidoDeOracion />
              <AppFooter setSelected={setSelected} />
            </>
          }
        />

        {/* Nuestra Fé Page */}
        <Route
          path="/nuestra_fe"
          element={
            <>
              <Navbar selected={selected} setSelected={setSelected} />
              <NuestraFe />
              <AppFooter setSelected={setSelected} />
            </>
          }
        />

        {/* Kids Page */}
        <Route
          path="/kids"
          element={
            <>
              <Navbar selected={selected} setSelected={setSelected} />
              <Kids />
              <AppFooter setSelected={setSelected} />
            </>
          }
        />

        {/* Material de Lectura Page */}
        <Route
          path="/material_lectura"
          element={
            <>
              <Navbar selected={selected} setSelected={setSelected} />

              <MaterialDeLectura />
              <AppFooter setSelected={setSelected} />
            </>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
